// Dependencies
import { FC, MouseEventHandler, useCallback, useState } from "react";

// Components
import IconList from "../IconList";
import SearchIcon from "@mui/icons-material/Search";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Typography } from "@mui/material";
import { IconButton } from "~/components/Common";

// Styles
import {
  StyledHeader,
  StyledWrapper,
} from "../CategoryPicker/CategoryPicker.styled";

// Icons

interface IconPickerProps {
  onSelect: Function;
  onClose: MouseEventHandler;
}

const IconPicker: FC<IconPickerProps> = ({ onSelect, onClose }) => {
  // states
  const [pickerTop, setPickerTop] = useState<number>(0);

  /** Calculate top position of picker to limit height */
  const pickerRef = useCallback((node: HTMLDivElement) => {
    if (node !== null) {
      setPickerTop(node.getBoundingClientRect().top);
    }
  }, []);

  return (
    <StyledWrapper
      sx={{
        maxHeight: `${window.innerHeight - pickerTop - 20}px`,
      }}
      ref={pickerRef}
    >
      <StyledHeader>
        <IconButton onClick={onClose}>
          <ChevronLeftIcon />
        </IconButton>
        <Typography variant={"h2"}>Icon list</Typography>
        <IconButton onClick={() => {}}>
          <SearchIcon />
        </IconButton>
      </StyledHeader>
      <IconList onSelect={onSelect} />
    </StyledWrapper>
  );
};

export default IconPicker;
